module.exports = __webpack_public_path__ + "static/media/OrdemServico3.49d18ddb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancOrdemServicos/OrdemServico3.png
// module id = 1766
// module chunks = 0